export const Loading = ({ notFixed }: { notFixed?: boolean }) => (
  <div
    className={`top-0 right-0 h-full w-full z-50 flex justify-center items-center ${
      notFixed ? "" : "fixed"
    }`}
  >
    <div className="loading h-8 w-8 text-secondary" />
  </div>
);
